module.exports = __webpack_public_path__ + "img/bahamas.cf321311.svg";